import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ImageThumbnailComponent } from '@web/shared/ui';
import { Guid, isNil, isNotNil, Nillable } from '@web/utils';
import { PublicBannerDataSourceService } from '../../services/public-banner-data-source.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-public-subscribe-banner-carousel-item',
  imports: [CommonModule, ImageThumbnailComponent, NgOptimizedImage],
  templateUrl: './public-subscribe-banner-carousel-item.component.html',
  styleUrl: './public-subscribe-banner-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicSubscribeBannerCarouselItemComponent {
  private readonly bannerDataSource = inject(PublicBannerDataSourceService);

  public readonly bannerId = input.required<Guid>();
  public readonly imageSrc = input.required<string>();
  public readonly mobileImageSrc = input<Nillable<string>>();
  public readonly imageAlt = input.required<string>();
  public readonly externalLink = input<Nillable<string>>();

  protected readonly isNotNil = isNotNil;

  public handleLinkClick(event: MouseEvent): void {
    event.preventDefault();

    const externalLink = this.externalLink();

    if (isNil(externalLink)) {
      return;
    }

    this.bannerDataSource
      .registerRedirectById(this.bannerId())
      .pipe(finalize(() => window.location.assign(externalLink)))
      .subscribe();
  }
}
